
import { defineComponent } from 'vue'
import { lovItemEnum } from '../../../LovsManagementDetail.vue'
import Dialog from 'primevue/dialog'
import lovsManagementInfoDialogDescriptor from './LovsManagementInfoDialogDescriptor.json'

export default defineComponent({
    name: 'lovs-management-info-dialog',
    components: { Dialog },
    emits: ['close'],
    props: {
        visible: { type: Boolean },
        infoTitle: { type: String },
        lovType: { type: Object }
    },
    data() {
        return {
            lovsManagementInfoDialogDescriptor,
            lovItemEnum
        }
    },
    created() {},
    methods: {}
})
